import axios from 'utils/axios';
import type {
    GetTaskListParamsType,
    GetTaskListResultType,
    TaskCardType,
    TaskCreateDataType,
    TaskRejectAnswerDataType,
    TaskSubmitAnswerDataType,
    TaskUpdateDatesDataType,
    TaskUpdateKanbanHideDataType,
    TaskUpdateUsersDataType,
} from '@econtractor/types';

export interface CreateTaskResult {
    stat: boolean;
    taskId?: number;
    errCode?: string;
}

export interface TaskActionResult {
    stat: boolean;
    task?: TaskCardType;
    errCode?: string;
}

export const getList = async (
    params: GetTaskListParamsType,
): Promise<GetTaskListResultType | null> => {
    try {
        const response = await axios('/tasks', { params });
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const getTask = async (taskId: number): Promise<TaskCardType | null> => {
    try {
        const response = await axios(`/tasks/${taskId}`);
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const createTask = async (data: TaskCreateDataType): Promise<CreateTaskResult | null> => {
    try {
        const response = await axios.post('/tasks/new', data);
        return response?.data || null;
    } catch (e: any) {
        if (e?.response?.data?.errCode) return e.response.data;
        console.error(e);
        return null;
    }
};

export const updateTaskStatus = async (
    taskId: number,
    status: number,
): Promise<TaskActionResult | null> => {
    try {
        const response = await axios.patch(`/tasks/${taskId}/status`, { status });
        return response?.data || null;
    } catch (e: any) {
        if (e?.response?.data?.errCode) return e.response.data;
        console.error(e);
        return null;
    }
};

export const updateTaskDates = async (
    taskId: number,
    data: TaskUpdateDatesDataType,
): Promise<TaskActionResult | null> => {
    try {
        const response = await axios.patch(`/tasks/${taskId}/dates`, data);
        return response?.data || null;
    } catch (e: any) {
        if (e?.response?.data?.errCode) return e.response.data;
        console.error(e);
        return null;
    }
};

export const updateTaskUsers = async (
    taskId: number,
    data: TaskUpdateUsersDataType,
): Promise<TaskActionResult | null> => {
    try {
        const response = await axios.patch(`/tasks/${taskId}/users`, data);
        return response?.data || null;
    } catch (e: any) {
        if (e?.response?.data?.errCode) return e.response.data;
        console.error(e);
        return null;
    }
};

export const updateTaskKanbanHide = async (
    taskId: number,
    data: TaskUpdateKanbanHideDataType,
): Promise<TaskActionResult | null> => {
    try {
        const response = await axios.patch(`/tasks/${taskId}/kanban-hide`, data);
        return response?.data || null;
    } catch (e: any) {
        if (e?.response?.data?.errCode) return e.response.data;
        console.error(e);
        return null;
    }
};

export const submitTaskAnswer = async (
    taskId: number,
    data: TaskSubmitAnswerDataType,
): Promise<TaskActionResult | null> => {
    try {
        const response = await axios.post(`/tasks/${taskId}/answer`, data);
        return response?.data || null;
    } catch (e: any) {
        if (e?.response?.data?.errCode) return e.response.data;
        console.error(e);
        return null;
    }
};

export const rejectTaskAnswer = async (
    taskId: number,
    data: TaskRejectAnswerDataType,
): Promise<TaskActionResult | null> => {
    try {
        const response = await axios.post(`/tasks/${taskId}/reject`, data);
        return response?.data || null;
    } catch (e: any) {
        if (e?.response?.data?.errCode) return e.response.data;
        console.error(e);
        return null;
    }
};

export const remindTaskExecutor = async (taskId: number): Promise<TaskActionResult | null> => {
    try {
        const response = await axios.post(`/tasks/${taskId}/remind`);
        return response?.data || null;
    } catch (e: any) {
        if (e?.response?.data?.errCode) return e.response.data;
        console.error(e);
        return null;
    }
};

export const deleteTask = async (taskId: number): Promise<TaskActionResult | null> => {
    try {
        const response = await axios.delete(`/tasks/${taskId}`);
        return response?.data || null;
    } catch (e: any) {
        if (e?.response?.data?.errCode) return e.response.data;
        console.error(e);
        return null;
    }
};
